import React, { useContext, useState } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import CustomerMasterLayout from "../../../../layouts/customer/CustomerMasterLayout";
import "../../../../assets/styles/customer/Customerbilling.css";
import axios from "axios";
import AppContext from "../../../../context/AppContext";

/* ══════════════════════════════════
   MOCK DATA
══════════════════════════════════ */
const MONTHLY_BILLS = [
  {
    month: "February 2026",
    total: "Rs 7,200",
    pending: "Rs 2,200",
    status: "Partial",
  },
  { month: "January 2026", total: "Rs 6,800", pending: "Rs 0", status: "Paid" },
  {
    month: "December 2025",
    total: "Rs 7,000",
    pending: "Rs 0",
    status: "Paid",
  },
  {
    month: "November 2025",
    total: "Rs 6,500",
    pending: "Rs 0",
    status: "Paid",
  },
  { month: "October 2025", total: "Rs 6,900", pending: "Rs 0", status: "Paid" },
  {
    month: "September 2025",
    total: "Rs 7,100",
    pending: "Rs 0",
    status: "Paid",
  },
  { month: "August 2025", total: "Rs 6,800", pending: "Rs 0", status: "Paid" },
  { month: "July 2025", total: "Rs 7,200", pending: "Rs 0", status: "Paid" },
  { month: "June 2025", total: "Rs 6,600", pending: "Rs 0", status: "Paid" },
  { month: "May 2025", total: "Rs 7,000", pending: "Rs 0", status: "Paid" },
  { month: "April 2025", total: "Rs 6,700", pending: "Rs 0", status: "Paid" },
  { month: "March 2025", total: "Rs 7,300", pending: "Rs 0", status: "Paid" },
];

const PAYMENT_HISTORY = [
  {
    id: 1,
    date: "Feb 15, 2026",
    amount: "Rs 3,000",
    method: "Cash",
    month: "February 2026",
  },
  {
    id: 2,
    date: "Feb 5, 2026",
    amount: "Rs 2,000",
    method: "Cash",
    month: "February 2026",
  },
  {
    id: 3,
    date: "Jan 28, 2026",
    amount: "Rs 3,800",
    method: "JazzCash",
    month: "January 2026",
  },
  {
    id: 4,
    date: "Jan 15, 2026",
    amount: "Rs 3,000",
    method: "Cash",
    month: "January 2026",
  },
  {
    id: 5,
    date: "Dec 20, 2025",
    amount: "Rs 4,000",
    method: "Cash",
    month: "December 2025",
  },
  {
    id: 6,
    date: "Dec 10, 2025",
    amount: "Rs 3,000",
    method: "EasyPaisa",
    month: "December 2025",
  },
];

const FILTER_OPTIONS = ["All", "Cash", "JazzCash", "EasyPaisa"];

// ── TODO: login ke baad yahan se aayega ──
const CUSTOMER_ID = localStorage.getItem("customerId");
const DISTRIBUTOR_ID = 1;

/* ══════════════════════════════════
   RECORD PAYMENT MODAL
══════════════════════════════════ */
const RecordPaymentModal = ({
  show,
  onHide,
  isPay = false,
  pendingAmount = "",
}) => {
  // ── STATES ──
  const [form, setForm] = useState({
    amount: "",
    method: "Cash",
    receipt: null,
  });
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [amount, setAmount] = useState();
  const [method, setMethod] = useState();
  const [reciept, setReciept] = useState(null);
  const [recieptName, setRecieptName] = useState("");
  const { baseUrl } = useContext(AppContext);

  const handleClose = () => {
    setForm({ amount: "", method: "Cash", receipt: null });
    setErrorMsg("");
    setSuccessMsg("");
    onHide();
  };

  // ── SUBMIT — API CALL ──
  const recordPayment = () => {
    console.log("record payment function  called", amount, method, reciept);
    setErrorMsg("");
    setSuccessMsg("");

    if (!amount) {
      setErrorMsg("Amount zaroori hai.");
      return;
    }

    setLoading(true);
    // console.log("🚀 Payment submit ho rahi hai...", form);
    console.log("Payment submit ho rahi hai...", amount, method, reciept);

    // ── FORM DATA ──
    const formData = new FormData();
    formData.append("mwcustomer_id", CUSTOMER_ID);
    // formData.append('mwdistributor_id', DISTRIBUTOR_ID);
    // formData.append("mwdistributor_id", 2);
    formData.append("amount", amount);
    formData.append("method", method);
    formData.append("recordedby", "customer");
    // if (form.receipt) {
    formData.append("reciept", reciept);
    // }

    axios
      .post(`${baseUrl}/customer/payment/recordPayment`, formData, {
        headers: { "Content-type": "multipart-formdata" },
      })
      .then((response) => {
        console.log(response.data);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });

    // ── API CALL ──
    // try {
    //   console.log('📡 API call ja rahi hai...');

    //   const response = await fetch('http://localhost:8000/api/customer/payment/recordPayment', {
    //     method: 'POST',
    //     body:   formData,
    //   });

    //   const data = await response.json();
    //   console.log('✅ Server response:', data);

    //   if (data.success) {
    //     setSuccessMsg('Payment record ho gai! ✅');
    //     setForm({ amount: '', method: 'Cash', receipt: null });
    //     setTimeout(() => handleClose(), 1500); // 1.5s baad modal band
    //   } else {
    //     setErrorMsg(data.message || 'Kuch masla hua, dobara koshish karein.');
    //     console.error('❌ Server error:', data.message);
    //   }

    // } catch (error) {
    //   console.error('❌ Fetch error:', error);
    //   setErrorMsg('Server se connect nahi ho saka.');
    // } finally {
    //   setLoading(false);
    // }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <div className="cbill-modal">
        <div className="cbill-modal__header">
          <div>
            <h6 className="cbill-modal__title">
              {isPay ? "Pay Now — February 2026" : "Record a Payment"}
            </h6>
            <p className="cbill-modal__sub">
              {isPay
                ? `Pending amount: ${pendingAmount}`
                : "Record a payment you've made to your distributor"}
            </p>
          </div>
          <button className="cbill-modal__close" onClick={handleClose}>
            <i className="bi bi-x" />
          </button>
        </div>

        <div className="cbill-modal__body">
          {/* ── Success / Error ── */}
          {successMsg && (
            <div
              style={{
                background: "#ecfdf5",
                color: "#16a34a",
                border: "1px solid #bbf7d0",
                borderRadius: 8,
                padding: "8px 12px",
                fontSize: 13,
                marginBottom: 12,
              }}
            >
              {successMsg}
            </div>
          )}
          {errorMsg && (
            <div
              style={{
                background: "#fef2f2",
                color: "#dc2626",
                border: "1px solid #fecaca",
                borderRadius: 8,
                padding: "8px 12px",
                fontSize: 13,
                marginBottom: 12,
              }}
            >
              {errorMsg}
            </div>
          )}

          {/* ── Amount ── */}
          <div className="cbill-form-group">
            <label className="cbill-form-label">Amount (Rs)</label>
            <input
              type="number"
              className="cbill-input"
              placeholder="Enter amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>

          {/* ── Method ── */}
          <div className="cbill-form-group">
            <label className="cbill-form-label">Method</label>
            <select
              className="cbill-input cbill-input--select"
              value={method}
              onChange={(e) => setMethod(e.target.value)}
            >
              <option>Cash</option>
              <option>JazzCash</option>
              <option>EasyPaisa</option>
              <option>Bank Transfer</option>
            </select>
          </div>

          {/* ── Receipt Upload ── */}
          <div className="cbill-form-group">
            <label className="cbill-form-label">
              Upload Receipt (optional)
            </label>
            <div className="cbill-file-wrap">
              <i className="bi bi-upload cbill-file-icon" />
              <span className="cbill-file-text">
                {recieptName != "" ? recieptName : "Choose file..."}
              </span>
              <input
                type="file"
                className="cbill-file-input"
                // value={toString(recieptName)}
                accept="image/*,application/pdf"
                onChange={(e) => {
                  setReciept(e.target.files[0]);
                  setRecieptName(e.target.files[0].name);
                }}
              />
            </div>
          </div>

          {/* ── Submit Button ── */}
          <button
            className="cbill-btn cbill-btn--primary cbill-btn--full"
            onClick={recordPayment}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit Payment"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

/* ══════════════════════════════════
   PAYMENT DETAILS MODAL
══════════════════════════════════ */
const PaymentDetailsModal = ({ payment, onHide }) => (
  <Modal show={!!payment} onHide={onHide} centered>
    {payment && (
      <div className="cbill-modal">
        <div className="cbill-modal__header">
          <h6 className="cbill-modal__title">Payment Details</h6>
          <button className="cbill-modal__close" onClick={onHide}>
            <i className="bi bi-x" />
          </button>
        </div>
        <div className="cbill-modal__body">
          <div className="cbill-detail-row">
            <span className="cbill-detail-label">Date</span>
            <span className="cbill-detail-value">{payment.date}</span>
          </div>
          <div className="cbill-detail-row">
            <span className="cbill-detail-label">Amount</span>
            <span className="cbill-detail-value cbill-detail-value--green">
              {payment.amount}
            </span>
          </div>
          <div className="cbill-detail-row">
            <span className="cbill-detail-label">Method</span>
            <span className="cbill-detail-value">{payment.method}</span>
          </div>
          <div className="cbill-detail-row">
            <span className="cbill-detail-label">Month</span>
            <span className="cbill-detail-value">{payment.month}</span>
          </div>
        </div>
      </div>
    )}
  </Modal>
);

/* ══════════════════════════════════
   MAIN
══════════════════════════════════ */
const CustomerBilling = () => {
  const [showRecord, setShowRecord] = useState(false);
  const [showPayNow, setShowPayNow] = useState(false);
  const [activePayment, setActivePayment] = useState(null);
  const [filter, setFilter] = useState("All");

  const filtered =
    filter === "All"
      ? PAYMENT_HISTORY
      : PAYMENT_HISTORY.filter((p) => p.method === filter);

  return (
    <CustomerMasterLayout>
      <div className="cbill-wrapper">
        {/* ── Header ── */}
        <div className="cbill-header">
          <div>
            <h1 className="cbill-title">Billing &amp; Payments</h1>
            <p className="cbill-subtitle">
              Your monthly bills and payment records
            </p>
          </div>
          <button
            className="cbill-btn cbill-btn--primary"
            onClick={() => setShowRecord(true)}
          >
            <i className="bi bi-plus me-1" />
            Record Payment
          </button>
        </div>

        {/* ── Yearly Summary ── */}
        <div className="cbill-card mb-3">
          <div className="cbill-yearly-head">
            <i className="bi bi-graph-up cbill-yearly-icon" />
            <span className="cbill-yearly-label">
              Yearly Summary (2025–2026)
            </span>
          </div>
          <Row className="g-3 mt-1">
            {[
              {
                label: "Total Billed",
                value: "Rs 83,100",
                color: "var(--tertiary-color)",
              },
              { label: "Total Paid", value: "Rs 80,900", color: "#22c55e" },
              { label: "Total Pending", value: "Rs 2,200", color: "#f59e0b" },
              {
                label: "Avg Monthly",
                value: "Rs 6,925",
                color: "var(--tertiary-color)",
              },
            ].map((s) => (
              <Col xs={6} md={3} key={s.label}>
                <p className="cbill-yearly-slabel">{s.label}</p>
                <p className="cbill-yearly-svalue" style={{ color: s.color }}>
                  {s.value}
                </p>
              </Col>
            ))}
          </Row>
        </div>

        {/* ── Monthly Bills ── */}
        <div className="cbill-card mb-3">
          <h2 className="cbill-card__title">Monthly Bills</h2>
          <div className="cbill-table-wrap">
            <table className="cbill-table">
              <thead>
                <tr>
                  <th>Month</th>
                  <th>Total</th>
                  <th>Pending</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {MONTHLY_BILLS.map((b, i) => (
                  <tr key={i}>
                    <td className="cbill-td--month">{b.month}</td>
                    <td>{b.total}</td>
                    <td
                      className={
                        b.status === "Partial" ? "cbill-td--pending" : ""
                      }
                    >
                      {b.pending}
                    </td>
                    <td>
                      <span
                        className={`cbill-status cbill-status--${b.status.toLowerCase()}`}
                      >
                        <span
                          className={`cbill-status__dot cbill-status__dot--${b.status.toLowerCase()}`}
                        />
                        {b.status}
                      </span>
                    </td>
                    <td>
                      {b.status === "Partial" && (
                        <button
                          className="cbill-paynow-btn"
                          onClick={() => setShowPayNow(true)}
                        >
                          Pay Now
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── Payment History ── */}
        <div className="cbill-card">
          <div className="cbill-card__head">
            <h2 className="cbill-card__title">Payment History</h2>
            <select
              className="cbill-filter-select"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            >
              {FILTER_OPTIONS.map((m) => (
                <option key={m}>{m}</option>
              ))}
            </select>
          </div>
          <div className="cbill-table-wrap">
            <table className="cbill-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Method</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((p) => (
                  <tr key={p.id}>
                    <td>{p.date}</td>
                    <td>{p.amount}</td>
                    <td>{p.method}</td>
                    <td>
                      <button
                        className="cbill-view-btn"
                        onClick={() => setActivePayment(p)}
                      >
                        <i className="bi bi-eye me-1" />
                        View
                      </button>
                    </td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr>
                    <td colSpan={4} className="cbill-empty">
                      No payments found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ── Modals ── */}
      <RecordPaymentModal
        show={showRecord}
        onHide={() => setShowRecord(false)}
      />
      <RecordPaymentModal
        show={showPayNow}
        onHide={() => setShowPayNow(false)}
        isPay
        pendingAmount="Rs 2,200"
      />
      <PaymentDetailsModal
        payment={activePayment}
        onHide={() => setActivePayment(null)}
      />
    </CustomerMasterLayout>
  );
};

export default CustomerBilling;
